export default "__VITE_ASSET__zJ$HfNQo__"